import { User } from '../user';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class LoginSerializer extends BaseSerializer {
  deserialize(raw) {
    const success = raw?.statusCode == 200;
    let parsedUser = null;
    if (success)
      parsedUser = {
        id: raw?.data?.id,
        email: raw?.data?.email,
        firstName: raw?.data?.firstName,
        lastName: raw?.data?.lastName,
        phoneNumber: raw?.data?.phoneNumber,
        countryCode: raw?.data?.countryCode,
        createdAt: raw?.data?.createdAt,
        updatedAt: raw?.data?.updatedAt,
        metadata: {
          ...raw?.data?.metadata
        }
      };

    const errorTexts = success
      ? null
      : errorMessages[`${raw?.statusCode}`] || errorMessages.other;
    return {
      success,
      statusCode: raw?.statusCode || 500,
      message: success ? 'ok' : errorTexts?.message,
      errorTitle: errorTexts?.title,
      user: success ? new User(parsedUser) : null
    };
  }

  serialize(data) {
    if (!data) return null;
    return {
      email: data.email,
      password: data.password
    };
  }
}

const errorMessages = {
  401: {
    title: 'Identifiants incorrects',
    message: 'Votre mot de passe est incorrect. Veuillez réessayer.'
  },
  404: {
    title: 'Email introuvable',
    message:
      'Aucun compte ne correspond à cet email. Veuillez vérifier et réessayer.'
  },
  400: {
    title: 'Erreur dans les données',
    message:
      'Les informations envoyées sont invalides. Veuillez vérifier et réessayer.'
  },
  other: {
    title: 'Échec de connexion',
    message: 'Une erreur inattendue s’est produite. Veuillez réessayer.'
  }
};

export const loginSerializer = new LoginSerializer();
